const apiUrls = {
  auth: {
    sign: {
      signIn: "/api/sign/in",
      signInPhone: "/api/sign/in-phone",
      signUp: "/api/sign/up",
      refreshToken: "/api/sign/refresh-token",
      activate: "/api/sign/activate-with-phone",
      signOut: "/api/sign/out",
      resetPassword: "/api/sign/reset-password",
      forgotPassword: "/api/sign/forgot",
      forgotPasswordReset: "/api/sign/forgot-reset",
    },
    user: {
      me: "/api/user/me",
      userWithCode: "/api/user",
      userProfile: "/api/user/user-profile",
      userProfileWithEmail: "/api/user/e-mail",
      userProfileWithPhone: "/api/user/phone",
      addGroup: "/api/user/group/all",
      userPage: "/api/user/page",
    },
  },
  salon: {
    customSalonData: {
      getCustomSalonData: "/api/CustomSalonData",
    },
    salon: {
      salon: "/api/Salon",
      salonByPath: "/api/Salon/by-path",
    },
  },
  employee: {
    employee: {
      getEmployeeSimpleBySalon: "/api/Employee/simple-by-salon",
    },
  },
  inventory: {
    inventory: {
      getInventoryBySalon: "/api/Inventory/by-salon",
    },
  },
  service: {
    service: {
      getBySalon: "/api/Service/by-salon",
    },
  },
  appointment: {
    appointment: {
      createAppointment: "/api/Appointment",
      getSimpleBySalon: "/api/Appointment/simple-by-salon",
      appointmentsByCustomer: "/api/Appointment/by-customer",
      myAppointments: "/api/Appointment/my-appointments",
      availableTimeSlots: "/api/Appointment/available-time-slots",
      sessionProgress: "/api/Appointment/get-session-progress",
    },
  },
  notification: {
    notification: {
      sendToUser: "/api/Notification/send-to-user",
      scheduleToUser: "/api/Notification/schedule-to-user",
    },
  },
  file: {
    file: {
      announcement: "/api/File/announcement",
      content: "/api/File/content",
      profilePhoto: "/api/File/profile-photo",
    },
  },
};

export default apiUrls;
